<!--
 * @Description: 生产计划
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 15:02:20
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">特材成品名称</span>
                  <el-input v-model="tableParam.productName" style="width: 240px" clearable placeholder="请输入"
                    @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">成品型号</span>
                  <el-input v-model="tableParam.productType" style="width: 240px" clearable placeholder="请输入"
                    @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.dataStatus" style="width: 120px" placeholder="请选择">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="未完工" :value="0"></el-option>
                    <el-option label="已完工" :value="1"></el-option>
                    <el-option label="已入库" :value="2"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">时间</span>
                  <el-date-picker v-model="paramTime" type="datetimerange" style="width: 220px" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false">
                  </el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small"
                class="bottom_all" style="margin-left: 0"
                @click="((productList = []), (disabledType = false), (changeStatus = false)), addFromDate('添加')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link v-if="ButtonList.findIndex(res => (res.buttonValue == 'DAOCHU')) !== -1" :underline="false"
                @click="load()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>
                导出
              </el-link>
            </div>
          </div>
          <div class="card" style="padding-top: 10px">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <div v-if="item.label == '备注'">
                        <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="bottom">
                          <div class="ellipsis2">{{ scope.row.remark }}</div>
                        </el-tooltip>
                      </div>
                      <el-link v-else-if="item.label == '生产计划编号'" class="table_link" :underline="false"
                        @click="open('addDialog', scope.row, true), (addDialogTitle = '查看')">{{ scope.row.code
                        }}</el-link>
                      <div v-else-if="item.label == '操作'">
                        <el-button
                          v-if="scope.row.dataStatus > 0 && scope.row.dataStatus != 3 && ButtonList.findIndex(res => res.buttonValue == 'RUKU') !== -1"
                          class="bottom_one" size="mini" :disabled="scope.row.dataStatus == 2"
                          @click="putStorage(scope.row)">
                          入库
                        </el-button>
                        <el-button
                          v-if="scope.row.dataStatus >= 2 && ButtonList.findIndex(res => res.buttonValue == 'RUKU') !== -1"
                          class="bottom_one" size="mini" :disabled="scope.row.dataStatus == 3"
                          @click="chongXiao(scope.row)">
                          冲销
                        </el-button>
                        <el-button
                          v-if="scope.row.dataStatus == 0 && ButtonList.findIndex(res => res.buttonValue == 'QUERENWANGONG') !== -1"
                          class="bottom_one" size="mini" @click="open('addDialog2', scope.row)">
                          确认完工
                        </el-button>
                        <el-button v-if="scope.row.dataStatus == 0" class="bottom_one" size="mini"
                          @click="open('addDialog', scope.row, false, true)"> 修改 </el-button>
                      </div>
                      <div v-else-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未完工</span>
                        <span v-else-if="scope.row.dataStatus == 1" style="color: #00a754">已完工</span>
                        <span v-else-if="scope.row.dataStatus == 2" style="color: red">已入库</span>
                        <span v-else-if="scope.row.dataStatus == 3" style="color: red">已冲销</span>
                      </div>
                      <div v-else-if="item.label == '生产类型'">
                        <span>{{ ["正常生产", "调料生产"][scope.row.planType] }}</span>
                      </div>
                      <div v-else-if="item.label == '入库检验结果'">
                        <span v-if="scope.row.storageTest == 'NG'" style="color: red">不合格</span>
                        <span v-else-if="scope.row.storageTest == 'OK'" style="color: #00a754">合格</span>
                        <span v-else style="color: #00a754">-</span>
                      </div>
                      <div v-else-if="item.label == '复检结果'">
                        <span v-if="scope.row.secondTest == 'NG'" style="color: red">不合格</span>
                        <span v-else-if="scope.row.secondTest == 'OK'" style="color: #00a754">合格</span>
                        <span v-else style="color: #00a754">-</span>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="600px" :close-on-click-modal="false"
      :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="companyId" :rules="[{ required: true, message: '请选择所属单位', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">所属单位</span>
            <el-select ref="company" v-model="fromDate.companyId" :disabled="disabledType" placeholder="请选择" @change="
              $nextTick(() => {
                fromDate.company = $refs.company.selectedLabel;
              }),
              productListFun(fromDate.companyId);
            querySpecialList(fromDate.companyId);
            changeProduct(fromDate.companyId);
            ">
              <el-option v-for="(item, index) in companyList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="neddSubjectId">
            <span slot="label" style="color: #ff0000">需求主体</span>
            <el-select v-model="fromDate.neddSubjectId" placeholder="请选择">
              <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"
                @click.native="changeSubject(item)"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productId">
            <span slot="label" style="color: #ff0000">特材成品</span>
            <el-select v-model="fromDate.productId" :disabled="disabledType" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in productList" :key="index" :label="item.productName + '-' + item.type"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="planType">
            <span slot="label" style="color: #ff0000">生产类型</span>
            <el-select v-model="fromDate.planType" :disabled="disabledType" placeholder="请选择" filterable>
              <el-option label="正常生产" :value="0"></el-option>
              <el-option label="调料生产" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="fromDate.planType === 1" prop="wasteTankId"
            :rules="[{ required: fromDate.planType === 1, message: '请选择成品罐', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">成品罐</span>
            <el-select ref="wasteTank" v-model="fromDate.wasteTankId" :disabled="disabledType" placeholder="请选择"
              filterable @change="
                $nextTick(() => {
                  fromDate.wasteTank = $refs.wasteTank.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in wasteTankList" :key="index" :label="item.tankName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="fromDate.planType === 1">
            <span slot="label" style="color: #ff0000">配合比设置</span>
            <span>按照每吨计算,剩余重量为水的比重</span>
            <el-button v-if="!disabledType" class="bottom_all_two" style="margin-left: 27px"
              @click.prevent="addItem2()">添加</el-button>
          </el-form-item>
          <el-table v-if="fromDate.planType === 1" :header-cell-style="{ background: '#f3f6f9' }"
            :cell-style="{ borderRight: 'none' }" border :row-class-name="tableRowClassName" style="width: 100%"
            :data="fromDate.mixtureRatioList" tooltip-effect="dark" class="FZYtable">
            <el-table-column label="原物料" align="center" prop="orderNo" width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '3'">{{ scope.row.rawName }}</span>
                <el-select v-else ref="specialMaterialsId" v-model="scope.row.specialMaterialsId" :disabled="disabledType"
                  placeholder="请选择" style="width: 100%" @change="
                    $nextTick(() => {
                      scope.row.rawName = $refs.specialMaterialsId.selectedLabel;
                    })
                    ">
                  <el-option v-for="(item, index) in specialList" :key="index" :label="item.rawtName"
                    :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="配合比值(KG)" align="center" prop="orderNo" width="auto">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.mixtureRatio" :controls="false" style="width: 80px"
                  :disabled="scope.row.formulaParametersId == 2 || disabledType"
                  @change="calculatorFun()"></el-input-number>
                <span>(KG)</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="100">
              <template slot-scope="scope">
                <el-button v-show="scope.$index > 0" :disabled="disabledType" size="mini" class="bottom_two"
                  @click="deleteItem(scope.$index)">
                  <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item v-for="(item, index) in fromDate.tankNums" :key="item.key" :rules="{
            required: true,
            message: '生产罐次不能为空',
            trigger: 'blur',
          }">
            <span slot="label" style="color: #ff0000">生产罐次</span>
            <el-input v-model="item.value" :disabled="disabledType" type="number"></el-input>
            <el-button v-if="!fromDate.productionTankNum" class="bottom_all_two"
              @click.prevent="removeTankNum(item, index)">{{ index === 0 ? "添加" : "删除" }}</el-button>
            <div>生产量：{{ `计算得出${(item.value * 10).toFixed(2)}吨` }}</div>
          </el-form-item>
          <el-form-item prop="remark">
            <span slot="label">备注</span>
            <el-input v-model="fromDate.remark" :disabled="disabledType" placeholder="请填写备注" class="textarea"
              type="textarea" resize="none" rows="5"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!disabledType" class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button v-if="!disabledType && !changeStatus" class="bottom_all" style="margin-left: 24px"
          @click="pagessubmitFromDate()">确 定</el-button>
        <el-button v-if="!disabledType && changeStatus" class="bottom_all" style="margin-left: 24px"
          @click="updatePlan()">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 入库 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog1" width="480px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">入库</span>
      <div>
        <div class="dialoginfotitle">生产量：{{ lowData.productNum }}</div>
        <div style="margin-bottom: 5px; display: flex; font-weight: 600">
          <div style="flex: 1">名称：{{ low.productName }}</div>
          <div style="flex: 1">型号：{{ low.productType }}</div>
        </div>
        <div style="margin-bottom: 5px; display: flex; font-weight: 600">
          <div style="flex: 1">入库时间：<el-date-picker v-model="lowData.inStoreTime" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"> </el-date-picker></div>
        </div>
        <div style="padding-bottom: 15px">
          <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="tankList.length == 0"
            @click="additem()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="lowData.tanks" tooltip-effect="dark" :row-class-name="className">
          <el-table-column label="成品罐" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.id" placeholder="请选择" style="width: 100%" @change="change(scope.row)">
                <el-option v-for="(item, index) in tankList" :key="index" :label="item.tankName"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="入库量" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.receipt" type="Number" placeholder="请输入" style="width: 100%">
                <template slot="append">吨</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delitem(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset('addDialog1')">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit1()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { querySpecialList } from "@/api/smart/specialmaterial/product.js";
import { queryPage, saveOrUpdate, productList, updateDataStatus, planWarehousing, tankList, getSpecialTankList, updatePlan, Download, planBack } from "@/api/smart/specialmaterial/prodplan.js";
import { getUserInfo } from "@/utils/auth";
import { permissionsCompanyList } from "@/api/common.js";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
export default {
  mixins: [mixin],
  data() {
    return {
      subjectList: [], //需求主体
      companyList: [],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      pagesType: 0,
      table: [
        { label: "生产计划编号", width: "160", prop: "code", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "所属单位", width: "120", prop: "company", status: true },
        { label: "需求主体", width: "120", prop: "neddSubject", status: true },
        { label: "特材成品名称", width: "120", prop: "productName", status: true },
        { label: "成品型号", width: "120", prop: "productType", status: true },
        { label: "生产类型", width: "120", prop: "planType", status: true },
        { label: "入库量（吨）", width: "120", prop: "warehousing", status: true },
        { label: "计划生产量（吨）", width: "120", prop: "production", status: true },
        { label: "备注", width: "200", prop: "remark", status: true },
        { label: "冲销备注", width: "200", prop: "backRemark", status: true },
        { label: "入库时间", width: "160", prop: "storageTime", status: true },
        { label: "完工时间", width: "160", prop: "completeTime", status: true },
        { label: "入库检验结果", width: "120", prop: "", status: true },
        { label: "复检结果", width: "120", prop: "", status: true },
        { label: "操作", width: "200", prop: "", status: true },
      ],
      rules: {
        productId: [{ required: true, message: "请选择特材成品", trigger: "change" }],
        productions: [{ required: true, message: "请输入罐次", trigger: "blur" }],
        production: [{ required: true, message: "请输入生产量", trigger: "blur" }],
      },
      fromDate: {
        companyId: "",
        neddSubject: "",
        neddSubjectId: "",
        productId: "",
        production: "",
        productions: "",
        wasteTankId: "",
        wasteTank: "",
        tankNums: [{ value: "" }],
        planType: 0,
        remark: "",
        mixtureRatioList: [
          {
            specialMaterialsId: "1", //特材原料记录中的rawId
            rawName: "成品罐用料", //特材原料记录中的rawtName
            mixtureRatio: "", //配合比值，单位KG，最多2位小数
            type: "3",
          },
        ],
      },
      productList: [],
      tankList: [],
      wasteTankList: [],
      lowData: {},
      low: {},
      addDialog1: false,
      specialList: [],
      disabledType: false,
      changeStatus: false,
      paramTime: [],
    };
  },
  watch: {
    paramTime(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.companyList = await permissionsCompanyList();
    this.tableParam = {
      ...this.tableParam,
      productName: "",
      productType: "",
      dataStatus: null,
      startTime: "",
      endTime: "",
    };
    this.gettableData();
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.subjectList = res.data;
      }
    });
  },
  methods: {
    //冲销
    chongXiao(low) {
      this.$prompt('', '冲销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (!value) {
          return this.$message({
            type: "warning",
            message: "请输入冲销原因!",
          });
        }
        planBack({
          id: low.id,
          giveUpReason: value
        }).then(res => {
          if (res.code == 1001) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          }
          this.gettableData();
        })
      })
    },
    changeSubject(item) {
      this.fromDate.neddSubject = item.name;
    },
    //获取原物料
    querySpecialList(id) {
      querySpecialList({ companyId: id }).then(res => {
        if (res.code == 1001) {
          this.specialList = res.data;
        }
      });
    },
    //配合比表添加
    addItem2() {
      let obj = {
        specialMaterialsId: "", //特材原料记录中的rawId
        rawName: "", //特材原料记录中的rawtName
        mixtureRatio: "", //配合比值，单位KG，最多2位小数
        type: "2",
      };
      this.fromDate.mixtureRatioList.push(obj);
    },
    deleteItem(index) {
      this.fromDate.mixtureRatioList.splice(index, 1);
    },
    /**前1个不能操作的改色--------下面都是配合比中的表格 */
    tableRowClassName({ rowIndex }) {
      if (rowIndex < 1) {
        return "ccc";
      }
    },
    putStorage(row) {
      if (row.storageTest == "OK" || row.secondTest == "OK") {
        this.open("addDialog1", row);
      } else if (!row.storageTest && !row.secondTest) {
        this.$message.warning("未检验，禁止入库！");
      } else {
        this.$message.warning("检验不合格，禁止入库！");
      }
    },
    async productListFun(companyId) {
      this.fromDate.productId = "";
      const { data } = await productList({ companyId: companyId, page: 1, pageSize: 9999999, enable: 1, dataType: 2 });
      this.productList = data.data;
    },
    changeProduct(id) {
      getSpecialTankList({ companyId: id, tankType: 2 }).then(res => {
        if (res.code === 1001) {
          this.wasteTankList = res.data;
        }
      });
    },
    /**
     * @Description: 如果index为0为新增罐次，否则为删除
     * @param {*} value
     * @param {*} index
     * @Author: wangwangwang
     */
    removeTankNum(value, index) {
      if (index === 0) {
        this.fromDate.tankNums.push({
          value: "",
        });
        return;
      }
      this.fromDate.tankNums.splice(index, 1);
    },
    changeValue(value) {
      this.fromDate.production = this.$regExp.FloatMul(value, 10);
    },
    change(low) {
      let item = this.tankList.find(res => res.id == low.id);
      low.inventory = item.inventory;
    },
    className({ row }) {
      if (row.status == 0) {
        return "hidden";
      }
    },
    additem() {
      this.lowData.tanks.push({
        id: "",
        inventory: "",
        receipt: "",
      });
    },
    delitem(index) {
      this.lowData.tanks.splice(index, 1);
    },
    reset(key) {
      this[key] = false;
      this.tankList = [];
    },
    submit1() {
      let _this = this;
      if (_this.lowData.tanks.length == 0) {
        _this.$message({
          message: "请添加入库数据",
          type: "warning",
        });
        return;
      }
      if (_this.lowData.tanks.every(item => item.id == "" || item.receipt == "")) {
        _this.$message({
          message: "请填写信息完整",
          type: "warning",
        });
        return;
      }
      /**去重*/
      let hash = {};
      const deWeight = (item, cur) => {
        hash[cur.id] ? "" : (hash[cur.id] = true && item.push(cur));
        return item;
      };
      let arr = _this.lowData.tanks.reduce(deWeight, []);
      /**合计*/
      const sum = (prev, cur) => prev + Number(cur.receipt);
      let num = _this.lowData.tanks.reduce(sum, 0);
      if (_this.lowData.tanks.length !== arr.length) {
        _this.$message({
          message: "不能添加重复的成品罐",
          type: "warning",
        });
        return;
      }
      if (_this.lowData.productNum !== num) {
        // _this.$message({
        //   message: '入库量之和要等于生产量',
        //   type: 'warning'
        // });
        // return
      }
      _this.lowData.storageTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
      planWarehousing(_this.lowData).then(res => {
        if (res.code == 1001) {
          _this.$message({
            message: "入库成功！",
            type: "success",
          });
          _this.reset("addDialog1");
          _this.gettableData();
        }
      });
    },
    /*重置数据*/
    init() {
      this.tableParam.productName = "";
      this.tableParam.productType = "";
      this.tableParam.dataStatus = null;
      this.gettableData();
    },
    async open(key, low, disabled, change) {
      this.low = this.copy(low);
      if (key == "addDialog") {
        this.changeStatus = change || false;
        this.disabledType = disabled;
        this[key] = true;
        this.addDialogTitle = "修改";
        this.productListFun(this.low.companyId);
        this.querySpecialList(this.low.companyId);
        this.changeProduct(this.low.companyId);
        this.fromDate = this.copy(low);
        this.fromDate["tankNums"] = [];
        let tankNums = [];
        let obj = {};
        this.$set(obj, "value", this.fromDate.productionTankNum);
        tankNums.push(obj);
        this.$set(this.fromDate, "tankNums", JSON.parse(JSON.stringify(tankNums)));
        // this.fromDate.mixtureRatioList= [
        //   {
        //     specialMaterialsId: "1", //特材原料记录中的rawId
        //     rawName: "成品罐用料", //特材原料记录中的rawtName
        //     mixtureRatio: "", //配合比值，单位KG，最多2位小数
        //     type:"3",
        //   },
        // ],
        this.fromDate = Object.assign({}, this.fromDate);
      }
      if (key == "addDialog1") {
        this[key] = true;
        const { data: list } = await tankList({ page: 1, pageSize: 9999999, productId: low.productId });
        this.tankList = list.data;
        let arr = [];
        if (list.data.length !== 0) {
          arr.push({
            id: "",
            inventory: "",
            receipt: "",
          });
        }
        this.lowData = {
          planId: low.id,
          planStatus: 2,
          productNum: low.production,
          tanks: arr,
        };
      }
      if (key == "addDialog2") {
        this.$confirm("此操作会将确认完工, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        })
          .then(() => {
            let data = {
              planId: low.id,
              planStatus: 1,
              companyId: low.companyId,
              company: low.company,
              materialNo: low.code,
              productId: low.productId,
              productName: low.productName,
              productModel: low.productType,
              completeTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
            };

            console.log(data);
            updateDataStatus(data).then(res => {
              if (res.code == 1001) {
                this.$message({
                  message: "已确认完工",
                  type: "success",
                });
                this.gettableData();
              }
            });
          })
          .catch(() => { });
      }
    },
    pagessubmitFromDate() {
      let _this = this;
      if (this.fromDate.tankNums.some(item => item.value === "")) {
        this.$message.warning("生产罐次不能为空");
        return;
      }
      _this.$refs.reffromDate.validate(async valid => {
        if (valid) {
          let item = _this.productList.find(res => res.id == _this.fromDate.productId);
          _this.fromDate.productName = item.productName;
          _this.fromDate.productType = item.type;
          _this.fromDate.tankNum = _this.fromDate.tankNums.map(item => item.value);
          getUserInfo();
          _this.submitFromDate();
        } else {
          return false;
        }
      });
    },
    updatePlan() {
      let _this = this;
      if (this.fromDate.tankNums.some(item => item.value === "")) {
        this.$message.warning("生产罐次不能为空");
        return;
      }
      _this.$refs.reffromDate.validate(async valid => {
        if (valid) {
          let item = _this.productList.find(res => res.id == _this.fromDate.productId);
          _this.fromDate.productName = item.productName;
          _this.fromDate.productType = item.type;
          _this.fromDate.tankNum = _this.fromDate.tankNums.map(item => item.value);
          _this.fromDate.productionTankNum = _this.fromDate.tankNums[0].value;
          getUserInfo();
          updatePlan(_this.fromDate).then(res => {
            this.loading = false;
            this.submitLoading = false;
            if (res.code === 1001) {
              this.resetFromDate();
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.gettableData();
            }
          });
        } else {
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input,
.el-select,
.el-textarea {
  width: 240px;
}

.hidden {
  display: none;
}

.dialoginfotitle {
  font-weight: bold;
  padding-bottom: 20px;
  font-size: 16px;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
</style>